export const GET_SEARCH_BOX_SUGGESTION_LIST = 'GET_SEARCH_BOX_SUGGESTION_LIST';

export const GET_SEARCH_BOX_SUGGESTION_LIST_SUCCESS = 'GET_SEARCH_BOX_SUGGESTION_LIST_SUCCESS';

export const GET_SEARCH_BOX_SUGGESTION_LIST_FAILED = 'GET_SEARCH_BOX_SUGGESTION_LIST_FAILED';